import { CALENDAR_VIEW, CHANGE_DATE_INTERNAL } from '../views/series/actions/event-series'

const initialState = {};

export const addHookActionTypeToReducerFieldMap = {
    ADD_RESERVATION_START_HOOK           : 'reservationStart',
    ADD_RESERVATION_COMPLETE_HOOK        : 'reservationComplete',
    ADD_RESERVATION_DATA_SET_HOOK        : 'reservationDataSet',
    ADD_RESERVATION_CLEAR_HOOK           : 'reservationClear',
    ADD_RESERVATION_EXPIRES_IN_HOOK      : 'reservationExpiresIn',
    ADD_LISTING_PRICE_LEVELS_UPDATE_HOOK : 'listingPriceLevelsUpdate',
    ADD_STATE_TRANSITION_HOOK            : 'stateTransition',
    ADD_GO_TO_CHECKOUT_HOOK              : 'goToCheckout',
    ADD_SET_PRICE_LEVELS_HOOK            : 'setPriceLevels',
    ADD_SET_BUNDLES_HOOK                 : 'setBundles',
    ADD_SET_PRODUCTS_HOOK                : 'setProducts',
    ADD_STATE_COUPON_SUBMISSION_HOOK     : 'couponSubmission',
    ADD_TICKETS_ADDED_TO_CART_HOOK       : 'ticketsAddedToCart',
    ADD_PRODUCTS_ADDED_TO_CART_HOOK      : 'productsAddedToCart',
    ADD_BUNDLES_ADDED_TO_CART_HOOK       : 'bundlesAddedToCart',
    ADD_TICKETS_REMOVED_FROM_CART_HOOK   : 'ticketsRemovedFromCart',
    ADD_PRODUCTS_REMOVED_FROM_CART_HOOK  : 'productsRemovedFromCart',
    ADD_BUNDLES_REMOVED_FROM_CART_HOOK   : 'bundlesRemovedFromCart',
    ADD_INSURANCE_OPTION_CHANGED_HOOK    : 'insuranceOptionChanged',
    ADD_CART_TIMER_EXTENDED_HOOK         : 'cartTimerExtended',
    ADD_CALENDAR_DATE_SELECTED_HOOK      : 'calendarDateSelected',
    ADD_CALENDAR_TIME_SELECTED_HOOK      : 'calendarTimeSelected',
    ADD_CALENDAR_DATE_CHANGED_HOOK       : 'calendarDateChanged',
    ADD_CALENDAR_VIEW_HOOK               : 'calendarView',
    ADD_TICKET_INCREMENT_HOOK            : 'ticketIncrement',
    ADD_TICKET_DECREMENT_HOOK            : 'ticketDecrement',
    ADD_PRODUCT_INCREMENT_HOOK           : 'productIncrement',
    ADD_PRODUCT_DECREMENT_HOOK           : 'productDecrement',
    ADD_BUNDLE_INCREMENT_HOOK            : 'bundleIncrement',
    ADD_BUNDLE_DECREMENT_HOOK            : 'bundleDecrement',
    ADD_CHECKOUT_OVERLAY_CHANGED_HOOK    : 'checkoutOverlay',
    ADD_MEMBERSHIP_VIEW_HOOK             : 'membershipView',
    ADD_MEMBERSHIP_SUCCESS_SIGNIN_HOOK   : 'membershipSuccessSignIn',
    ADD_MEMBERSHIP_SIGNOUT_HOOK          : 'membershipSignOut',
    ADD_MEMBERSHIP_GO_TO_SIGNIN_HOOK     : 'membershipGoToSignIn',
    ADD_MEMBERSHIP_SKIP_SIGNIN_HOOK      : 'membershipSkipSignIn',
    ADD_TICKET_CHANGE_QUANTITY_HOOK      : 'ticketChangeQuantity',
    ADD_PRODUCT_CHANGE_QUANTITY_HOOK     : 'productChangeQuantity',
    ADD_BUNDLE_CHANGE_QUANTITY_HOOK      : 'bundleChangeQuantity',
    ADD_PERSONAL_DETAILS_CHANGED_HOOK    : 'personalDetailsChanged',
    ADD_CONTINUE_SHOPPING_HOOK           : 'continueShopping',
    ADD_MARKETING_DISABLE_HOOK           : 'disableMarketing',
    ADD_ROKT_EVENT_HOOK                  : 'roktEventView',
};

Object.values(addHookActionTypeToReducerFieldMap).forEach(field => {
    initialState[field] = [];
})

export function hooks(state: State = initialState, action): State {
    if (Object.keys(addHookActionTypeToReducerFieldMap).includes(action.type)) {
        let newState = {...state};
        newState[addHookActionTypeToReducerFieldMap[action.type]].push(action.hook);
        return newState;
    } else if(action.type === "RESERVATION_CREATED") {
        for (let hookFunction of state.reservationStart) {
            hookFunction();
        }
        return state;
    } else if(action.type === "RESERVATION_DATA_SET") {
        for (let hookFunction of state.reservationDataSet) {
            hookFunction(action.reservation, action.forward);
        }
        return state;
    } else if(action.type === "RESERVATION_COMPLETED") {
        for (let hookFunction of state.reservationComplete) {
            hookFunction();
        }
        return state;
    } else if(action.type === "RESERVATION_CLEARED") {
        for (let hookFunction of state.reservationClear) {
          hookFunction(action.forward, action.reason);
        }
        return state;
    } else if(action.type === "RESERVATION_EXPIRES_IN") {
        for (let hookFunction of state.reservationExpiresIn) {
            hookFunction(action.timeRemaining);
        }
        return state;
    } else if(action.type === "router/SET_CURRENT_ROUTE_NAME") {
        let page = action?.value;
        // ticketPicker fires when the picker is still invisible, it's handled elsewhere
        // checkout is handled by the step seen trigger below
        if(page === 'ticketPicker' || page === "checkout") {
            if (page === 'checkout') {
              for (let hookFunction of state.goToCheckout) {
                  hookFunction();
              }
            }
          
            return state;
        }

        for (let hookFunction of state.stateTransition) {
            hookFunction(page);
        }
        return state;
    } else if (action.type === "SET_PRICE_LEVELS") {
        const empty = !action.data || !Object.keys(action.data).length;

        for (let hookFunction of state.setPriceLevels) {
            hookFunction(action.data, empty, action.subReducerKey);
        }
        return state;
    } else if (action.type === "SET_BUNDLES") {
        const empty = !action.data || !Object.keys(action.data).length;

        for (let hookFunction of state.setBundles) {
            hookFunction(action.data, empty, action.subReducerKey);
        }
        return state;
    } else if (action.type === "SET_PRODUCTS") {
        const empty = !action.data || !Object.keys(action.data).length;

        for (let hookFunction of state.setProducts) {
            hookFunction(action.data, empty, action.subReducerKey);
        }
        return state;
    } else if(action.type === "TICKET_PICKER_OPENED") {
        for (let hookFunction of state.stateTransition) {
            hookFunction('ticketPicker');
        }
        return state;
    } else if(action.type === "CHECKOUT_STEP_SEEN") {
        let page = 'checkout-' + (action.index + 1);
        for (let hookFunction of state.stateTransition) {
            hookFunction(page);
        }
        return state;
    } else if(action.type === "COUPON_SUBMITTED") {
        for (let hookFunction of state.couponSubmission) {
            hookFunction(action.code);
        }
        return state;
    } else if (action.type === 'TICKETS_ADDED_TO_CART') {
        if (Array.isArray(state.ticketsAddedToCart)) {
            for (let hookFunction of state.ticketsAddedToCart) {
                hookFunction(action.tickets);
            }
        }
        return state;
    } else if (action.type === 'TICKETS_REMOVED_FROM_CART') {
        if (Array.isArray(state.ticketsRemovedFromCart)) {
            for (let hookFunction of state.ticketsRemovedFromCart) {
                hookFunction(action.tickets);
            }
        }
        return state;
    } else if (action.type === 'PRODUCTS_ADDED_TO_CART') {
        if (Array.isArray(state.productsAddedToCart)) {
            for (let hookFunction of state.productsAddedToCart) {
                hookFunction(action.products);
            }
        }
        return state;
    } else if (action.type === 'PRODUCTS_REMOVED_FROM_CART') {
        if (Array.isArray(state.productsRemovedFromCart)) {
            for (let hookFunction of state.productsRemovedFromCart) {
                hookFunction(action.products);
            }
        }
        return state;
    } else if (action.type === 'BUNDLES_ADDED_TO_CART') {
        if (Array.isArray(state.bundlesAddedToCart)) {
            for (let hookFunction of state.bundlesAddedToCart) {
                hookFunction(action.bundles);
            }
        }
        return state;
    } else if (action.type === 'BUNDLES_REMOVED_FROM_CART') {
        if (Array.isArray(state.bundlesRemovedFromCart)) {
            for (let hookFunction of state.bundlesRemovedFromCart) {
                hookFunction(action.bundles);
            }
        }
        return state;
    } else if (action.type === 'INCREMENT_PRICE_LEVEL') {
        if (Array.isArray(state.ticketIncrement)) {
            for (let hookFunction of state.ticketIncrement) {
                hookFunction(action.id);
            }
        }
        return state;
    } else if (action.type === 'DECREMENT_PRICE_LEVEL') {
        if (Array.isArray(state.ticketDecrement)) {
            for (let hookFunction of state.ticketDecrement) {
                hookFunction(action.id);
            }
        }
        return state;
    } else if (action.type === 'SET_PRICE_LEVEL') {
        if (Array.isArray(state.ticketChangeQuantity)) {
            for (let hookFunction of state.ticketChangeQuantity) {
                hookFunction(action.id, action.value);
            }
        }
        return state;
    } else if (action.type === 'INCREMENT_PRODUCT') {
        if (Array.isArray(state.productIncrement)) {
            for (let hookFunction of state.productIncrement) {
                hookFunction(action.id);
            }
        }
        return state;
    } else if (action.type === 'DECREMENT_PRODUCT') {
        if (Array.isArray(state.productDecrement)) {
            for (let hookFunction of state.productDecrement) {
                hookFunction(action.id);
            }
        }
        return state;
    } else if (action.type === 'SET_PRODUCT') {
        if (Array.isArray(state.productChangeQuantity)) {
            for (let hookFunction of state.productChangeQuantity) {
                hookFunction(action.id, action.value);
            }
        }
        return state;
    } else if (action.type === 'INCREMENT_BUNDLE') {
        if (Array.isArray(state.bundleIncrement)) {
            for (let hookFunction of state.bundleIncrement) {
                hookFunction(action.id);
            }
        }
        return state;
    } else if (action.type === 'DECREMENT_BUNDLE') {
        if (Array.isArray(state.bundleDecrement)) {
            for (let hookFunction of state.bundleDecrement) {
                hookFunction(action.id);
            }
        }
        return state;
    } else if (action.type === 'SET_BUNDLE') {
        if (Array.isArray(state.bundleChangeQuantity)) {
            for (let hookFunction of state.bundleChangeQuantity) {
                hookFunction(action.id, action.value);
            }
        }
        return state;
    } else if (action.type === 'SET_INSURANCE_OPTION') {
        if (Array.isArray(state.insuranceOptionChanged)) {
            for (let hookFunction of state.insuranceOptionChanged) {
                hookFunction(action);
            }
        }
        return state;
    } else if (action.type === 'EXTEND_TIME') {
      for (let hookFunction of state.cartTimerExtended) {
        hookFunction();
      }
      return state;
    } else if (action.type === 'SET_SELECTED_DATE') {
        if (Array.isArray(state.calendarDateSelected)) {
            for (let hookFunction of state.calendarDateSelected) {
                hookFunction(action.date);
            }
        }
        return state;
    } else if (action.type === 'SET_SELECTED_EVENT') {
        if (Array.isArray(state.calendarTimeSelected)) {
            for (let hookFunction of state.calendarTimeSelected) {
                hookFunction(action.data);
            }
        }
        return state;
    } else if (action.type === CHANGE_DATE_INTERNAL) {
        if (Array.isArray(state.calendarDateChanged)) {
            for (let hookFunction of state.calendarDateChanged) {
                hookFunction(action.hook);
            }
        }
        return state;
    } else if (action.type === CALENDAR_VIEW) {
        if (Array.isArray(state.calendarView)) {
            for (let hookFunction of state.calendarView) {
                hookFunction(action.data);
            }
        }
        return state;
    } else if (action.type === "CHECKOUT_OVERLAY") {
        if (Array.isArray(state.checkoutOverlay)) {
            for (let hookFunction of state.checkoutOverlay) {
                hookFunction(action.overlay);
            }
        }
        return state;
    } else if (action.type === "UI_MEMBERSHIP_VIEW_PAGE") {
        if (Array.isArray(state.membershipView)) {
            for (let hookFunction of state.membershipView) {
                hookFunction();
            }
        }
        return state;
    } else if (action.type === "UI_MEMBERSHIP_SUCCESS_SIGNIN") {
      if (Array.isArray(state.membershipSuccessSignIn)) {
          for (let hookFunction of state.membershipSuccessSignIn) {
              hookFunction(action.data);
          }
          return state;
      }
    } else if (action.type === "UI_MEMBERSHIP_SIGNOUT") {
      if (Array.isArray(state.membershipSignOut)) {
          for (let hookFunction of state.membershipSignOut) {
              hookFunction();
          }
          return state;
      }
    } else if (action.type === "UI_MEMBERSHIP_GO_TO_SIGNIN") {
      if (Array.isArray(state.membershipGoToSignIn)) {
          for (let hookFunction of state.membershipGoToSignIn) {
              hookFunction();
          }
          return state;
      }
    } else if (action.type === "UI_SET_SKIP_MEMBERSHIP") {
      if (Array.isArray(state.membershipSkipSignIn)) {
          for (let hookFunction of state.membershipSkipSignIn) {
              hookFunction(action.val);
          }
          return state;
      }
    } else if (action.type === "UI_SET_DISABLE_MARKETING") {
      if (Array.isArray(state.disableMarketing)) {
        for (let hookFunction of state.disableMarketing) {
          hookFunction(action.val);
        }
      }
      return state;
    } else if (action.type === "REPORT_PERSONAL_DETAILS_CHANGED") {
        if (Array.isArray(state.personalDetailsChanged)) {
            for (let hookFunction of state.personalDetailsChanged) {
                hookFunction(action.value);
            }
        }
        return state;
    } else if (action.type === "UI_CONTINUE_SHOPPING") {
        if (Array.isArray(state.continueShopping)) {
            for (let hookFunction of state.continueShopping) {
                hookFunction();
            }
        }
        return state;
    } else if(action.type === 'ROKT_EVENT') {
        if (Array.isArray(state.roktEventView)) {
          for (let hookFunction of state.roktEventView) {
            hookFunction(action.val);
          }
        }
        return state;
    } else {
        return state;
    }
}
